import { useRef } from 'react';

// Props for a modal's backdrop so it closes only on a click that both starts
// and ends on the backdrop itself. Without this, pressing inside the modal
// (say, to select text in a field) and releasing outside it counts as a click
// on the backdrop and closes the modal.
//
//   <div className="backdrop" {...useBackdropClose(close)}> ... </div>
export default function useBackdropClose(onClose) {
  const pressedOnBackdrop = useRef(false);

  return {
    onMouseDown: (e) => {
      pressedOnBackdrop.current = e.target === e.currentTarget;
    },
    onClick: (e) => {
      const close = pressedOnBackdrop.current && e.target === e.currentTarget;
      pressedOnBackdrop.current = false;
      if (close) onClose();
    },
  };
}
